export const tabelaVeiculoFormStructure = [
  [
    {
      name: 'id',
      label: 'Id',
      component: 'FormField',
      type: 'number',
      colProps: { md: 2 },
      readOnly: true,
      disabled: true
    },
    {
      name: 'numeroFrota',
      label: 'Numero Frota',
      component: 'FormField',
      type: 'text',
      colProps: { md: 4 },
      maxLength: 50
    },
    {
      name: 'idTabelaPremiacao',
      label: 'Id Tabela Premiacao',
      component: 'FormField',
      type: 'number',
      colProps: { md: 4 }
    },
    {
      name: 'ativo',
      label: 'Ativo',
      component: 'CheckBox',
      type: 'checkbox',
      colProps: { md: 2 }
    }
  ]
];

export const tabelaVeiculoFormSections = () => [
  { title: 'Associacao Frota x Tabela', rows: [0] }
];

export const validateTabelaVeiculoForm = (values) => {
  const errors = {};

  if (!values.numeroFrota || !String(values.numeroFrota).trim()) {
    errors.numeroFrota = 'Numero da frota e obrigatorio';
  }

  if (!values.idTabelaPremiacao) {
    errors.idTabelaPremiacao = 'Id da tabela e obrigatorio';
  }

  return errors;
};

export const emptyTabelaVeiculoForm = {
  id: '',
  numeroFrota: '',
  idTabelaPremiacao: '',
  ativo: true
};
